import { render, staticRenderFns } from "./HeadYoga.vue?vue&type=template&id=598348e4&"
import script from "./HeadYoga.vue?vue&type=script&lang=js&"
export * from "./HeadYoga.vue?vue&type=script&lang=js&"
import style0 from "./HeadYoga.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports